import React from 'react';
import { ShieldCheck, Clock, Lock, Zap, FileText } from 'lucide-react';
import { Button } from './ui';
import { trackInitiateCheckout } from './useMetaPixel';
import { useCountdown } from '../hooks/useCountdown';
import { CHECKOUT_URL, costs, prices } from '../data/kit';
export function CostOfInaction() {
  const {
    units
  } = useCountdown({
    h: 23,
    m: 59,
    s: 34
  });
  return <section className="py-12 px-3 sm:px-4 bg-white" data-id="element-27" data-mp="34w03pq436sqa">
      <div className="max-w-5xl mx-auto mb-12" data-id="element-28" data-mp="34v8fj0ctjxa1">
        <h2 className="font-serif text-xl sm:text-2xl md:text-3xl font-bold text-wine text-center mb-5" data-id="element-29" data-mp="38xlkhmjqrr5r">
          ⚖️ ¿CUÁNTO TE CUESTA SEGUIR SIN UN CAMINO CLARO?
        </h2>
        <div className="rounded-2xl border border-cream-400 overflow-hidden" data-id="element-30" data-mp="3dqeq0cn1b3iw">
          <table className="w-full text-left border-collapse table-fixed" data-id="element-31" data-mp="3imwvxfu3p7wt">
            <colgroup data-id="element-32" data-mp="3nnkjtsn198mt">
              <col className="w-[48%]" data-id="element-33" data-mp="3no2kr2kn4b12" />
              <col className="w-[52%]" data-id="element-34" data-mp="3slclvfhe6b4q" />
            </colgroup>
            <thead data-id="element-35" data-mp="3slud1xp75z5s">
              <tr className="bg-cream-100 border-b border-cream-400" data-id="element-36" data-mp="3sj85hy2b3jnk">
                <th className="px-3 sm:px-5 py-2.5 text-[11px] sm:text-xs font-semibold uppercase tracking-wider text-ink-soft" data-id="element-37" data-mp="3ei12psiah1pb">
                  Sin un recorrido claro
                </th>
                <th className="px-3 sm:px-5 py-2.5 text-[11px] sm:text-xs font-bold uppercase tracking-wider text-rose-700 bg-rose-50" data-id="element-38" data-mp="34isfdihxilbx">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-cream-300" data-id="element-39" data-mp="13nzvc5gccfd">
              {costs.map(([problem, cost]) => <tr key={problem} data-id="element-40" data-mp="3sa7b2sf7a4e7">
                  <td className="px-3 sm:px-5 py-3 text-[13px] sm:text-base text-ink-muted leading-snug" data-id="element-41" data-mp="3ngctbuj5nzhr">
                    {problem}
                  </td>
                  <td className="px-3 sm:px-5 py-3 text-[13px] sm:text-base font-semibold text-wine leading-snug bg-rose-50/60" data-id="element-42" data-mp="3jdq8idkwjeu2">
                    {cost}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-43" data-mp="299oqt11mslzg">
        <p className="font-serif text-xl md:text-2xl font-bold text-wine" data-id="element-44" data-mp="2e8t0dssgwlqb">
          LOS PRÓXIMOS 30 DÍAS PUEDEN SER DIFERENTES.
        </p>
        <p className="font-serif text-xl md:text-2xl font-bold text-rose-600 mt-1" data-id="element-45" data-mp="1ziu4jwodxme0">
          Esta vez vas a saber qué practicar hoy y qué viene después.
        </p>

        <p className="mt-9 flex items-center justify-center gap-2 font-bold text-wine text-base md:text-lg" data-id="element-46" data-mp="1qifi2tzoq18x">
          <Clock className="w-5 h-5 text-rose-500" data-id="element-47" data-mp="1vitf7gzqzqs6" />
          EL PRECIO CIERRA EN:
        </p>
        <div className="mt-4 flex items-start justify-center gap-3 sm:gap-6" role="timer" data-id="element-48" data-mp="1glkmojypkgyv">
          {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-49" data-mp="1ljuj0xw65nm2" data-mpi={i}>
              {i > 0 && <span className="font-serif text-rose-300 font-bold text-4xl sm:text-5xl leading-none" aria-hidden="true" data-id="element-50" data-mp="3azlgurjbcfsm">
                  :
                </span>}
              <div className="text-center" data-id="element-51" data-mp="149i7s0mwt5wo">
                <p className="tabular-nums font-serif font-bold text-rose-600 text-5xl sm:text-6xl leading-none" data-id="element-52" data-mp="14ajiu53xdsee">
                  {String(unit.value).padStart(2, '0')}
                </p>
                <p className="mt-2 text-[11px] font-semibold tracking-[0.3em] text-ink-soft" data-id="element-53" data-mp="1e1nx12ls1986">
                  {unit.label}
                </p>
              </div>
            </React.Fragment>)}
        </div>

        <div className="max-w-md mx-auto mt-8 rounded-3xl border-2 border-rose-400 bg-white p-5 sm:p-6 shadow-[0_24px_55px_-28px_rgba(34,56,107,0.4)]" data-id="element-54" data-mp="1n2uhfmrjr46p">
          <h3 className="font-serif font-bold text-wine text-lg sm:text-xl tracking-tight leading-tight" data-id="element-55" data-mp="1wxw6yjpqi89t">
            ⭐ KIT DESAFÍO LECTOR
          </h3>
          <p className="text-sm text-rose-600 font-bold mt-1" data-id="element-56" data-mp="1ry1h8jhp3oqc">3 Módulos + 5 Bonos</p>
          <span className="inline-block mt-2 bg-lila-100 text-lila-600 text-[10px] font-extrabold uppercase tracking-[0.16em] px-2.5 py-1 rounded-full" data-id="element-57" data-mp="2n0maj19z2qo">
            Oferta de lanzamiento
          </span>
          <p className="text-xs font-bold uppercase tracking-widest text-ink-soft mt-4" data-id="element-58" data-mp="3vah6a595uk5y">
            Antes <span className="line-through text-rose-600" data-id="element-59" data-mp="446d0vae6np6">{prices.before}</span>
          </p>
          <p className="text-xs font-bold uppercase tracking-widest text-ink-soft mt-2" data-id="element-60" data-mp="91y11e7x1po3">
            Ahora
          </p>
          <p className="font-serif text-5xl sm:text-6xl font-bold text-wine leading-none tracking-tight mt-1" data-id="element-61" data-mp="dxwuvhc0jzvw">
            {prices.now}
          </p>
          <span className="inline-block mt-2.5 bg-sage-100 text-sage-600 text-[11px] font-extrabold uppercase tracking-wide px-3 py-1 rounded-full" data-id="element-62" data-mp="3hi18biv49cbw">
            Ahorrás {prices.saving}
          </span>
          <p className="text-xs text-ink-muted mt-3" data-id="element-63" data-mp="3r7kw92xorwdm">✓ Pago único · ⚡ Acceso inmediato</p>
          <Button className="w-full mt-4 text-base py-4" onClick={() => {
          trackInitiateCheckout();
          window.location.href = CHECKOUT_URL;
        }} data-id="element-64" data-mp="2tqcetz6k6htd">
            → QUIERO MI KIT DESAFÍO LECTOR
          </Button>
        </div>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-ink-muted mt-6" data-id="element-65" data-mp="1btiqkpvfo9a0">
          <span className="flex items-center" data-id="element-66" data-mp="16twdcgflut17">
            <Lock className="w-4 h-4 mr-1 text-ink-soft" data-id="element-67" data-mp="16wsba4rgdhpn" /> Pago seguro
          </span>
          <span className="flex items-center" data-id="element-68" data-mp="11vcrsh4xbj9d">
            <Zap className="w-4 h-4 mr-1 text-rose-500" data-id="element-69" data-mp="wx1gs32w72pk" /> Acceso inmediato
          </span>
          <span className="flex items-center" data-id="element-70" data-mp="s61lf29f8sp6">
            <ShieldCheck className="w-4 h-4 mr-1 text-sage-600" data-id="element-71" data-mp="s48d7ij5u0f2" /> Garantía 7 días
          </span>
          <span className="flex items-center" data-id="element-72" data-mp="o4prikjillb6">
            <FileText className="w-4 h-4 mr-1 text-rose-500" data-id="element-73" data-mp="j5d6848akmap" /> Material digital e imprimible
          </span>
        </div>
      </div>
    </section>;
}